import { FLAGS } from '@gozoki/feature-flags'
import { FeatureRouteGuard, RightsRouteGuard } from '~/components/route-guards'
import type { PermissionRequirement } from '~/utils/rbac'
import { LOGISTICS_LEGACY_RIGHTS } from './tabs'

/**
 * Gardes des routes Logistique : flag `logistique`, puis droit demandé avec repli sur le bit
 * `LOGISTICS` tant que `permission-v2` est OFF (cf. `FeatureRouteGuard`, `RightsRouteGuard`).
 */
export function LogisticsRouteGuard({
  permission,
  children,
}: React.PropsWithChildren<{ permission: PermissionRequirement }>) {
  return (
    <FeatureRouteGuard flag={FLAGS.logistique}>
      <RightsRouteGuard permission={permission} legacyRights={LOGISTICS_LEGACY_RIGHTS}>
        {children}
      </RightsRouteGuard>
    </FeatureRouteGuard>
  )
}
